import { createMuiTheme } from '@material-ui/core/styles';
//import teal from '@material-ui/core/colors/teal';
//import red from '@material-ui/core/colors/red';

export default createMuiTheme({
    overrides: {
        MuiFormLabel: {
            root: {
                fontWeight: 400
            }
        }
    },
    palette: {
        primary: { main: '#009788' },
        secondary: { main: '#1fa9a3' }
    },
    typography: {
        useNextVariants: true,
        fontSize: 20,
        //fontFamily: [
        //    'Segoe UI', 'Tahoma', 'Geneva', 'Verdana', 'sans-serif'
        //].join(',')
    },
    //spacing: {

    //}
    
});

//import { withStyles } from '@material-ui/core/styles';

//export default withStyles({
//    '@global': {
//        body: {
//            fontFamily: 'Arial',
//        },
//    },
//})(() => null);


// WEBPACK FOOTER //
// ./src/theme.js